import { useQuery } from '@tanstack/react-query';
import { apiAssetsHost } from '../../../utils/ApiService';
import { ApiLocalStorage } from '../../../utils/ApiLocalStorage';
import { handleApiError } from 'components/ErrorHandler';
import routes from 'components/pages/Routes';

export const SCHEMA_STORAGE_KEY = 'account_schema';

interface AccountSchemaResponse {
    [key: string]: ThemeData;
}

interface ThemeData {
    logo?: string;
    background?: string;
    [key: string]: any;
}

export const useGetAccountSchema = () => useQuery(
    ['getAccountSchema'],
    async () => {
        const cachedData = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
        
        try {
            const fetchPromise = apiAssetsHost.get<AccountSchemaResponse>('/account/schema.json')
                .then(response => {
                    const rawData = response.data || response;
                    
                    // Remove itens vazios ou com option 'None'
                    const cleanData = Object.fromEntries(
                        Object.entries(rawData).filter(([_, value]) => !(
                                (value.formFields && value.formFields.length === 0) || 
                                value.option === 'None'
                            ))
                    );

                    ApiLocalStorage.set(SCHEMA_STORAGE_KEY, cleanData);
                    
                    return cleanData;
                })
                .catch((error) => {
                    window.location.hash = routes.construction.path;
                    handleApiError(error, 'Erro ao carregar schema');
                    
                    return cachedData || {};
                });

            return cachedData ? Promise.resolve(cachedData) : fetchPromise;
        } catch (error) {
            window.location.hash = routes.construction.path;
            handleApiError(error, 'Erro ao carregar schema');
            
            return cachedData || {};
        }
    },
    {
        staleTime: Infinity,
        cacheTime: Infinity,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    }
); 